import { bytesToBase64Url } from "./base64url";

// OAuth2 PKCE, S256 only (internal/auth/pkce.go:13-23 rejects anything
// else and enforces the RFC 7636 43..128 verifier length).

export interface PkcePair {
  verifier: string;
  challenge: string;
}

/** 32 random bytes -> 43-char base64url verifier (RFC 7636 §4.1). */
export function generateCodeVerifier(): string {
  const bytes = new Uint8Array(32);
  crypto.getRandomValues(bytes);
  return bytesToBase64Url(bytes);
}

export async function codeChallengeS256(verifier: string): Promise<string> {
  const digest = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(verifier));
  return bytesToBase64Url(digest);
}

export async function generatePkcePair(): Promise<PkcePair> {
  const verifier = generateCodeVerifier();
  return { verifier, challenge: await codeChallengeS256(verifier) };
}
